import { Paper, PaperProps } from "@mui/material";
import Draggable from "react-draggable";

function DraggableFunction(props: PaperProps) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      bounds="parent"
      onDrag={(e: any, data) => {
        const parentElement =
          e.target instanceof HTMLElement ? e.target.parentElement : null;
        if (!parentElement) return;

        const parentBounds = parentElement.getBoundingClientRect();
        const dialogBounds = e.target.getBoundingClientRect();

        const newBounds = {
          top: parentBounds.top - dialogBounds.top,
          left: parentBounds.left - dialogBounds.left,
          right:
            parentBounds.right -
            dialogBounds.right +
            window.innerWidth -
            dialogBounds.width,
          bottom:
            parentBounds.bottom -
            dialogBounds.bottom +
            window.innerHeight -
            dialogBounds.height,
        };
      }}
    >
      <Paper {...props} sx={{ ...props.style, ...{ position: "relative" } }} />
    </Draggable>
  );
}

export default DraggableFunction;
